import styled from 'styled-components';

import { GridContainer } from '@xing-com/grid';
import { mediaWideNavless } from '@xing-com/layout-tokens';
import { spaceL, spaceXL, spaceXXL } from '@xing-com/tokens';

export const StyledGridContainer = styled(GridContainer)`
  column-gap: ${spaceL};
  row-gap: ${spaceXXL};

  @media ${mediaWideNavless} {
    row-gap: ${spaceXL};
  }
`;
